import { CustomFields } from "@web-app/components";
import { FieldValue, Order } from "@web-app/types";

export default function AdditionalDetailsTab({
  order,
  debouncedOnChange,
}: {
  debouncedOnChange: (property: string, value: FieldValue) => void;
  order: Order;
}) {
  const workspaceId = order.connectedWorkspaceId || order.workspaceId;

  return (
    <div className="space-y-3 lg:space-y-4 px-4 lg:pb-20 pb-10">
      <CustomFields
        entity="order"
        entityId={order.id}
        workspaceId={workspaceId}
        entityObject={order}
        onChange={(_, customField, value) => {
          const existingCustomFieldIndex = order.customFields.findIndex(
            (cf) => cf.definition.id === customField.id,
          );

          if (existingCustomFieldIndex > -1) {
            const updatedCustomFields = [...order.customFields];

            updatedCustomFields[existingCustomFieldIndex] = {
              definition: customField,
              values: value,
            };

            debouncedOnChange("customFields", updatedCustomFields);
          } else {
            const updatedCustomFields = [
              ...order.customFields,
              {
                definition: customField,
                values: value,
              },
            ];

            debouncedOnChange("customFields", updatedCustomFields);
          }
        }}
      />
    </div>
  );
}
